import React from "react";
import { Link } from "react-router-dom";
import ErrorBgImg from "../Assets/img/error-page-bg.svg";

const NotFoundPage = () => {
  return (
    <>
      <section className="notfound-page-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2 col-md-8 offset-md-2 col-12">
              <div className="notfound-page-inner">
                <div className="notfound-page-img">
                  <img src={ErrorBgImg} alt="#" />
                </div>
                <div className="notfound-page-btn">
                  <Link to="/" className="eschool-btn secondary-btn">
                    Back to home
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default NotFoundPage;
